import Modal from '~/components/modal';
import axios from 'axios';
import {
  delegate
} from '../helpers/utils';

/* eslint-disable */
(function () {
  const QuickBuyModal = context => {
    const ctx = context || document;

    const strings = {
      quickBuyCard: 'data-qb-pid',
      quickBuyButton: 'data-qb-button',
      quickBuySingleVariant: 'data-qb-single-variant',
      quickBuyModalContent: 'data-qb-modal-content',
      productLinkTemplateAttr: 'data-qb-url',
      variantProxyImgAttr: 'data-variant-id'

    };

    const selectors = {
      modalId: 'modal-qb',
      quickBuyCard: '[' + strings.quickBuyCard + ']',
      quickBuyButton: '[' + strings.quickBuyButton + ']',
      quickBuyModalContent: '[' + strings.quickBuyModalContent + ']',
      cardSwatches: '.product-card__variant',
      quickBuyAddToCart: '[data-qb-add-to-cart]',
      quickBuyHoverTrigger: '[' + strings.quickBuyHoverTrigger + ']',
      productForm: '.qb__product-form',
      productFormTemplate: '.qb__product-form-template',
      priceContainer: '.product-price',
      productLinkTemplate: '[' + strings.productLinkTemplateAttr + ']',
      productCardThumbsContainer: '.product-card__thumbnail-container',
      productFormOption: '.product-form__option'
    };

    const quickBuyButtons = ctx.querySelectorAll(`${selectors.quickBuyCard} ${selectors.quickBuyButton}`);
    const quickBuyModalContent = document.querySelector(selectors.quickBuyModalContent);

    if (quickBuyButtons.length) {
      const modal = Modal({
        id: selectors.modalId,
      });

      const modalEl = document.getElementById(selectors.modalId);

      if (!modalEl) return;

      const updateSelectedVariantImage = function (variantId) {
        const variantProxyImgContainer = modalEl.querySelector(selectors.productCardThumbsContainer);
        if (!variantProxyImgContainer) return;

        const variantImgProxy = variantProxyImgContainer.querySelector('[' + strings.variantProxyImgAttr + '="' + variantId + '"]');
        if (!variantImgProxy) return;

        const variantImages = variantProxyImgContainer.querySelectorAll('[' + strings.variantProxyImgAttr + ']');
        if (variantImages.length) {
          const variantImgsList = Array.from(variantImages);
          variantImgsList.map(variantImg => {
            variantImg.style = 'display:none;';
          });

          variantImgProxy.style = "display:block;"
        }
      }

      const getSelectedVariantUrl = function (variantId) {
        const linkEl = modalEl.querySelector(selectors.productLinkTemplate);
        const linkStart = linkEl.getAttribute(strings.productLinkTemplateAttr);
        return linkStart + variantId;
      }

      const updateSelectedVariantLink = function (newLink) {
        const linkEl = modalEl.querySelector(selectors.productLinkTemplate);
        linkEl.setAttribute('href', newLink);
      }

      const resetSelectedVariantLink = function () {
        const linkEl = modalEl.querySelector(selectors.productLinkTemplate);
        const newLink = linkEl.getAttribute(strings.productLinkTemplateAttr);
        linkEl.setAttribute('href', newLink.replace('?variant=', ''));
      }

      const enableAddToCart = function () {
        const addToCart = modalEl.querySelector(selectors.quickBuyAddToCart);
        if (addToCart) {
          addToCart.innerText = window.theme.strings.quick_buy.addToCart;
          addToCart.removeAttribute('disabled');
        }
      }

      const disableAddToCart = function () {
        const addToCart = modalEl.querySelector(selectors.quickBuyAddToCart);
        if (addToCart) {
          addToCart.innerText = window.theme.strings.quick_buy.unavailable;
          addToCart.setAttribute('disabled', 'disabled');
        }
      }

      const fetchVariantPDPHtml = function (variantUrl, callback) {
        axios.get(variantUrl)
          .then(response => {
            const parser = new DOMParser();
            const html = parser.parseFromString(response.data, 'text/html');
            if (callback && typeof callback === 'function') {
              callback(html);
            }
            return response;
          })
          .catch((error) => {
            throw new Error(error);
          });

      }

      // Change price with current variant one
      const updateSelectedVariantPrice = function (html) {
        const priceContainer = html.querySelector('.product-form ' + selectors.priceContainer);
        const modalPriceContainer = modalEl.querySelector(selectors.priceContainer);
        if (modalPriceContainer) modalPriceContainer.innerHTML = priceContainer.innerHTML;

        showPrice();
      }

      const hidePrice = function () {
        const priceContainer = modalEl.querySelector(selectors.priceContainer);
        if (priceContainer) priceContainer.classList.add('disabled');
      }

      const showPrice = function () {
        const priceContainer = modalEl.querySelector(selectors.priceContainer);
        if (priceContainer) priceContainer.classList.remove('disabled');
      }

      const swatchSelector = '.swatch-grid__item';
      delegate('click', modalEl, swatchSelector, function (e) {
        if (this.matches(swatchSelector)) {
          this.classList.add('is-active')
        }
      });

      const onQBFormChange = function () {
        const inputs = modalEl.querySelectorAll('input');

        if (inputs.length) {
          const inputsList = Array.from(inputs);
          let selectedVariant = [];
          inputsList.map(input => {
            if (input.checked) {
              selectedVariant.push(input.value);
            }
          });


          if (selectedVariant.length) {
            selectedVariant = selectedVariant.join(' / ');
            const masterSelector = modalEl.querySelector('[js-product-form="masterSelector"]');
            const msOptions = masterSelector.querySelectorAll('option');

            if (msOptions.length) {
              const msOptionsList = Array.from(msOptions);
              const selectedOption = msOptionsList.find(option => {
                const cleanOptionText = option.innerText.trim();
                const cleanSelectedVariant = selectedVariant.trim();
                return cleanOptionText === cleanSelectedVariant;
              });
      
              if (selectedOption) {
                const selectedVariantId = selectedOption.value;
      
                  if (selectedVariantId) {
                    const variantUrl = getSelectedVariantUrl(selectedVariantId);
      
                    if (variantUrl) {
                      updateSelectedVariantLink(variantUrl);
                      fetchVariantPDPHtml(variantUrl, updateSelectedVariantPrice);
                      updateSelectedVariantImage(selectedVariantId);
                    }
      
                    masterSelector.value = selectedVariantId;
                  }

                if (!selectedOption.hasAttribute('disabled')) {
                  enableAddToCart();
                  
                } else {
                  disableAddToCart();
                }
              }
            }
          }
        }
      };
      
      

      delegate('change', modalEl, 'input', onQBFormChange);

      delegate('click', modalEl, '.qb-modal__close', function (e) {
        modal.close(selectors.modalId);
      });

      delegate('click', modalEl, '[data-qb-add-to-cart]', function (e) {
        const masterSelector = modalEl.querySelector('[js-product-form="masterSelector"]');
        const inputValues = {};

        const bundlePropertyElement = modalEl.querySelector('input[name="properties[Bundle]"]');
        if (bundlePropertyElement) {
          inputValues['Bundle'] = bundlePropertyElement.value;
        }

        axios.post('/cart/add.js', {
            items: [{
              id: masterSelector.value,
              quantity: 1,
              properties: inputValues
            }]
          })
          .then(response => {
            modal.close(selectors.modalId);
            Frame.EventBus.emit('AjaxCart:itemAdded', response);
            return response;

          })
          .catch((error) => {
            throw new Error(error);
          });
      });

      // Move product form inside its placeholder
      const moveProductForm = function (card) {
        const template = card.querySelector(selectors.productFormTemplate);

        const templateContent = template.content.cloneNode(true);
        const productForm = card.querySelector(selectors.productForm);

        productForm.appendChild(templateContent);
      }

      const setupModalContent = function (card) {
        const proxyCard = card.cloneNode(true);

        moveProductForm(proxyCard);

        quickBuyModalContent.innerHTML = '';
        quickBuyModalContent.append(proxyCard);
        hidePrice();

        // Fetch first product price
        const productFormOption = quickBuyModalContent.querySelector(selectors.productFormOption);
        if(!productFormOption) {
          const masterSelector = quickBuyModalContent.querySelector('[js-product-form="masterSelector"]');
          const selectedUrl = getSelectedVariantUrl(masterSelector.value);
          fetchVariantPDPHtml(selectedUrl, updateSelectedVariantPrice);
          updateSelectedVariantLink(selectedUrl);
        }

        // Trigger form change, it loads first selected variant
        onQBFormChange();
      };

      const initQuickBuyModal = function (item) {
        const card = item.closest(selectors.quickBuyCard);

        if (!card || !quickBuyModalContent) return;

        setupModalContent(card);

        modal.show(selectors.modalId);
      };

      const quickBuyButtonsList = Array.from(quickBuyButtons);

      quickBuyButtonsList.map(function (quickBuyButton) {
        quickBuyButton.addEventListener('click', e => {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }

          const item = e.target;
          const itemId = item.getAttribute(strings.quickBuySingleVariant);
          if (itemId) {
            axios.post('/cart/add.js', {
                items: [{
                  id: itemId,
                  quantity: 1
                }]
              })
              .then(response => {
                Frame.EventBus.emit('AjaxCart:itemAdded', response);
                return response;
              })
              .catch((error) => {
                throw new Error(error);
              });
          } else {
            initQuickBuyModal(item);
          }
        });
      });

      modal.init({
        onShow: (container) => (console.log('show')),
        onClose: (container) => (console.log('hide')),
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function (e) {
    QuickBuyModal();
  });

  document.addEventListener('Alessi:quickBuyInit', function (e) {
    QuickBuyModal(e.detail.context);
  });

  document.addEventListener('Alessi:loadMoreEnd', function (e) {
    QuickBuyModal();
  });
})();
/* eslint-enable */
